/**
 * Plugin to handle chunk loading failures
 * This catches errors when users have cached HTML that references
 * old chunk files after a new deployment
 */
export default defineNuxtPlugin((nuxtApp) => {
  const reloadKey = 'nuxt:chunk-reload'
  const maxReloadAttempts = 1

  nuxtApp.hook('app:chunkError', ({ error }) => {
    // Get current reload count from sessionStorage
    const reloadCount = parseInt(sessionStorage.getItem(reloadKey) || '0', 10)

    if (reloadCount < maxReloadAttempts) {
      sessionStorage.setItem(reloadKey, String(reloadCount + 1))
      // Reload to get fresh chunks
      window.location.reload()
    }
  })

  // Handle unhandled rejections for dynamic import failures
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason

    // Check if this is a chunk loading error
    if (
      error &&
      (error.message?.includes('Failed to fetch dynamically imported module') ||
        error.message?.includes('Load failed') ||
        error.message?.includes('Loading chunk') ||
        error.message?.includes('ChunkLoadError'))
    ) {
      const reloadCount = parseInt(sessionStorage.getItem(reloadKey) || '0', 10)

      if (reloadCount < maxReloadAttempts) {
        sessionStorage.setItem(reloadKey, String(reloadCount + 1))
        event.preventDefault()
        window.location.reload()
      }
    }
  })

  // Clear reload counter on successful page load
  nuxtApp.hook('page:finish', () => {
    sessionStorage.removeItem(reloadKey)
  })
})
